/**
 * Tooltips shown on hover/focus for KPI cards. Keyed by the KPI `id` returned
 * from the backend so adding a new KPI later just needs an entry here.
 */
export const KPI_TOOLTIPS = {
  cash_available:    "Total cash across all connected bank accounts right now.",
  cash_runway:       "How many days you can operate at current spending rate before cash runs out.",
  revenue_mtd:       "Total sales invoices raised this calendar month.",
  debtors:           "Total money owed to you by customers not yet paid.",
  debtors_outstanding:"Total money owed to you by customers not yet paid.",
  gst_due:           "Net GST payable to the government this month after deducting input tax credit.",
  gst_payable:       "Net GST payable to the government this month after deducting input tax credit.",
  net_profit_mtd:    "Revenue minus all costs this month.",
  health_score:      "Composite score out of 100 across 7 business dimensions.",
  inventory_value:   "Total value of stock in your warehouse.",
  inventory_turns:   "How many times you sold and replaced your stock in the last 90 days. Higher is better.",
  slow_moving_stock: "Inventory with no movement in the last 90 days.",
  gross_margin:      "Percentage of revenue remaining after direct production costs.",
  ebitda_margin:     "Operating profit as a percentage of revenue, before interest, tax, depreciation and amortisation.",
  cash_cycle:        "Average days from paying suppliers to collecting from customers.",
  ccc_days:          "Average days from paying suppliers to collecting from customers.",
  working_capital:   "Current assets minus current liabilities.",
};
